package com.devi3east.bashbuddy.account.organization.domain.models

import kotlinx.serialization.Serializable

@Serializable
data class StripeAccount(
    val accountId: String,
    val onboardingComplete: Boolean = false,
    val currentlyDue: List<String> = emptyList(),
    val eventuallyDue: List<String> = emptyList()
)